import { styled } from '@/stitches.config';

const Card = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '$4',
  justifyContent: 'space-around',
});

const TitleContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  gap: '$2',
});

const Title = styled('h3', {
  margin: 0,
  fontSize: '$sm',
  fontWeight: '$bold',
  lineHeight: '$3',
  textTransform: 'uppercase',
  color: '$darkGray300',
  textAlign: 'left',
});

const SecondaryLabel = styled('span', {
  color: '$darkGray300',
  fontSize: '$xs',
  lineHeight: '$3',
  fontWeight: '$light',
  textAlign: 'left',
});

const Value = styled('span', {
  fontSize: '$4',
  lineHeight: '$3',
  fontWeight: '$bold',
  color: '$darkBlue400',
  textAlign: 'left',
});

interface MetricCardProps {
  id: string;
  title: string;
  value: string | JSX.Element;
  secondaryLabel?: string;
  boldTitle?: boolean;
}

export const MetricCard = ({ id, title, value, secondaryLabel, boldTitle = false }: MetricCardProps): JSX.Element => {
  return (
    <Card data-testid={id}>
      <TitleContainer>
        <Title css={{ fontWeight: boldTitle ? 'bold' : 'normal' }}>{title}</Title>
        {secondaryLabel && <SecondaryLabel>{secondaryLabel}</SecondaryLabel>}
      </TitleContainer>
      {typeof value === 'string' ? <Value>{value}</Value> : value}
    </Card>
  );
};
